import React from 'react';

const LoadingSpinner = ({ 
  size = 'medium', 
  color = 'primary', 
  text,
  className = '' 
}) => {
  const sizeClasses = {
    small: 'w-5 h-5',
    medium: 'w-10 h-10',
    large: 'w-16 h-16',
    xl: 'w-20 h-20',
  };

  const colorClasses = {
    primary: 'border-primary-200 border-t-primary-500',
    blue: 'border-blue-200 border-t-blue-500',
    gray: 'border-gray-200 border-t-gray-500',
    green: 'border-green-200 border-t-green-500',
    red: 'border-red-200 border-t-red-500',
    yellow: 'border-yellow-200 border-t-yellow-500',
  };

  const spinnerClasses = `
    ${sizeClasses[size]}
    ${colorClasses[color] || colorClasses.primary}
    border-4 rounded-full animate-spin
  `.trim();

  return (
    <div className={`flex flex-col items-center justify-center gap-4 ${className}`}>
      <div className={spinnerClasses} />
      {text && (
        <div className="text-gray-600 text-sm font-medium animate-pulse">
          {text}
        </div>
      )}
    </div>
  );
};

export default LoadingSpinner;
